<template>
    <div>
        <template v-if="!showWrongExam">
            <!-- Chi tiết khóa học -->
            <div class="div-week" v-show="!showWrongAnswer">
                
                <!-- Progess -->
                <progess :data="data"/>

                <template>
                    <!-- Lịch sử thi - pc  -->
                    <history-exam-pc :data="data" v-on:clickShowWrongExam="clickShowWrongExam($event)" v-if="!mobile"/>

                    <!-- Lịch sử thi - mobile -->
                    <history-exam-mobile :data="data" v-if="mobile"/>

                    <!-- Menu -->
                    <menu-list :data="data"/>
                    
                </template>

                <!-- Loading -->
                <loading class="loading--lesson" :showLoading="loading" />
            </div>

            <!-- Danh sách câu trả lời sai -->
            <wrong-answer v-if="showWrongAnswer" :data="dataWrongAnswer" />
        </template>
        <!-- Danh sách câu trả lời bài thi sai -->
        <listWrongExam v-if="showWrongExam" :data="dataWrongExam" v-on:clickShowWrongExam="clickShowWrongExam($event)"/>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    // Nhúng component
    import loading from "@/components/loading/loading";
    import wrongAnswer from "@/components/manage/detail/wrongAnswer";
    import listWrongExam from "@/components/manage/detail/listWrongExam";
    import historyExamPc from "@/components/manage/detail/historyExamPc";
    import historyExamMobile from "@/components/manage/detail/historyExamMobile";
    import menuList from "@/components/manage/detail/menu";
    import progess from "@/components/manage/detail/progess";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                showWrongExam: false,
                dataWrongExam: []
            };
        },
        components: {
            loading,
            wrongAnswer,
            historyExamPc,
            historyExamMobile,
            menuList,
            progess,
            listWrongExam
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                showWrongAnswer: (state) => state.manageDetail.showWrongAnswer,
                dataWrongAnswer: (state) => state.manageDetail.dataWrongAnswer,
                loading: (state) => state.manageDetail.loading
            }),
        },
        methods: {
            ...mapMutations("manageDetail", []),
            clickShowWrongExam(params) {
                this.$emit("clickShowWrongExamDt", params);
                this.showWrongExam = params.showTypeWrongExam;
                this.dataWrongExam = params.list;
            }
        }
    };
</script>

<style scoped>
    .tb-week img {
        cursor: unset;
    }
    .noTitle span {
        cursor: unset;
    }
    .noTitle span:hover {
        color: black;
    }

    /* ---------- */
    .dot.dot--studing {
        background: #da251d;
    }
    .nqtLearnPercent {
        margin-bottom: 15px;
    }
    .parent-ul-ol {
        margin-bottom: 0;
        text-transform: none;
        color: #000000;
        font-size: 14px;
        font-weight: normal;
    }
    span.caret.caret-down {
        text-transform: none;
        color: #000000;
    }
    .parent-ul {
        font-size: 14px;
    }
    .nqt-mobie {
        display: none;
    }
    @media (max-width: 834px) {
        .nqt-mobie {
            display: block;
        }
    }
    @media (max-width: 480px) {
        .tb-week img {
            margin: 0 !important;
        }
        .btn-number {
            margin-left: 0 !important;
        }
    }
    .done_score a {
        background: #118e07;
    }
    .exam_begins_box {
        margin: 15px auto 0 !important;
    }
    .nameTestExam {
        padding-left: 22px;
        font-size: 15px;
    }
    @media (max-width: 480px) {
        .nameTestExam {
            padding-left: 6px;
            font-size: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/detail/content.vue